import { MapPin, User, House, MessageSquare, ShieldCheck, Phone, Mail, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function ValuePropositionBar() {
  const benefits = [{
    icon: MapPin,
    title: "Western Suburbs Expertise",
    desc: "Guidance across Naperville, Plainfield, Wheaton, St. Charles, Oswego, Schaumburg, and nearby communities."
  }, {
    icon: User,
    title: "Buyer-Focused Support",
    desc: "Personalized guidance throughout your home search, financing, and next steps."
  }, {
    icon: House,
    title: "Financing Guidance",
    desc: "Explore financing options and closing cost assistance programs with a trusted lending partner.*"
  }, {
    icon: MessageSquare,
    title: "Responsive Communication",
    desc: "Clear communication and local insight designed to simplify the buying process."
  }];
  const team = [{
    name: "Anish Patel, MBA",
    role: "Dream Realty Services",
    bio: "Buyer-focused real estate guidance across Chicago's western suburbs.",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/Hero Image.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/Hero Image.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/Hero Image.png-wvc-sizes",
      alt: "Anish Patel"
    }
  }, {
    name: "Manish Shah",
    role: "Genex Lending",
    bio: "Helping buyers explore financing options with clarity and confidence.",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/Screenshot 2026-05-09 at 3.34.57 PM.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/Screenshot 2026-05-09 at 3.34.57 PM.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/Screenshot 2026-05-09 at 3.34.57 PM.png-wvc-sizes",
      alt: "Manish Shah"
    }
  }];
  return <section id="value-proposition-bar" className="bg-[#0a1120] text-white py-16 lg:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          
          {}
          <div className="lg:col-span-4 flex flex-col justify-center space-y-8">
            <div className="space-y-4">
              <h2 className="text-4xl md:text-5xl font-bold font-default leading-tight tracking-tight">
                Local Guidance.<br />
                <span className="text-accent-gold">Personalized Support.</span>
              </h2>
              <div className="w-12 h-1 bg-accent-gold rounded-lg"></div>
            </div>
            
            <p className="text-gray-300 text-lg leading-relaxed max-w-md">
              Dream Realty Services and Genex Lending work together to help buyers across Chicago's western suburbs navigate the home search and financing process with confidence.
            </p>

            <div className="space-y-4">
              
              <div className="flex items-center gap-2 text-sm text-gray-400">
                <ShieldCheck className="size-4 text-accent-gold" />
                <span>Your information is secure and never shared.</span>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-4 space-y-8">
            {benefits.map((benefit, i) => <div key={i} data-index={i} className="flex gap-5 group">
                <div className="flex-shrink-0 size-14 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-accent-gold group-hover:bg-white/10 transition-colors">
                  <benefit.icon className="size-6" />
                </div>
                <div className="space-y-1">
                  <h3 className="text-lg font-bold font-default text-white">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    {benefit.desc}
                  </p>
                </div>
              </div>)}
          </div>

          {}
          <div className="lg:col-span-4 space-y-10">
            <h3 className="text-xl font-bold text-accent-gold font-default">
              Meet Your Local Team
            </h3>
            
            <div className="grid grid-cols-2 gap-6">
              {team.map((member, i) => <div key={i} data-index={i} className="space-y-4">
                  <div className="relative aspect-[4/5] rounded-lg overflow-hidden border-2 border-accent-gold/20">
                    <img src={member.image.src} data-wvc-srcset={member.image.srcset} data-wvc-sizes={member.image.sizes} alt={member.image.alt} className="w-full h-full object-cover object-top" loading="lazy" />
                  </div>
                  <div className="space-y-1">
                    <h4 className="font-bold text-white text-base leading-tight">
                      {member.name}
                    </h4>
                    <p className="text-accent-gold text-xs font-semibold uppercase tracking-wider">
                      {member.role}
                    </p>
                    <p className="text-gray-400 text-xs leading-relaxed">
                      {member.bio}
                    </p>
                  </div>
                </div>)}
            </div>

            <div className="pt-6 border-t border-white/10 flex items-start gap-3">
              <div className="size-10 rounded-lg bg-white/5 flex items-center justify-center text-accent-gold flex-shrink-0">
                <User className="size-5" />
              </div>
              <p className="text-xs text-gray-400 leading-relaxed">
                A collaborative real estate and lending experience designed to help you move forward with confidence.
              </p>
            </div>
          </div>

        </div>

        {}
        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-8">
          <div className="flex items-start gap-4 max-w-xl">
            <ShieldCheck className="size-6 text-accent-gold flex-shrink-0 mt-1" />
            <p className="text-xs text-gray-500 leading-relaxed">
              Information is provided for general purposes only and is not a commitment to lend. 
              Programs vary by buyer qualification and lender approval.
            </p>
          </div>
          
          <div className="flex flex-wrap justify-center md:justify-end gap-8">
            <div className="flex items-center gap-3 text-gray-300 hover:text-accent-gold transition-colors">
              <Phone className="size-5 text-accent-gold" />
              <span className="font-semibold">(815) 546-0725</span>
            </div>
            <div className="flex items-center gap-3 text-gray-300 hover:text-accent-gold transition-colors">
              <Mail className="size-5 text-accent-gold" />
              <span className="font-semibold">realestatewithanish@gmail.com</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}